export default __webpack_public_path__ + "static/media/catholic200sg.b9da4a07.png";